import {effect, Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {SessionService} from './session.service';


// This service ensures that the authentication state and session state are synchronized without causing cyclic updates or circular dependencies.
@Injectable({
  providedIn: 'root'
})
export class UserContextFacadeService {

  constructor(private readonly authService: AuthService,
              private readonly sessionService: SessionService) {
    effect(() => {
      const isAuthenticated = this.authService.authenticated();
      const sessionUser = this.sessionService.session().user;
      const ongoingLogout = this.authService.ongoingLogout();
      const ongoingLogin = this.sessionService.session().ongoingLogin;

      // If not authenticated but session user exists, revoke session
      if (!isAuthenticated && sessionUser !== undefined) {
        // If a logout is ongoing, we can directly revoke the session without further checks.
        if (ongoingLogout) {
          this.sessionService.revokeSession();
          return;
        }
        // If no logout is ongoing, we need to verify the authentication state with the backend via cookies.
        this.authService.authenticate().subscribe(cookiesAuthValid => {
          if (!cookiesAuthValid) {
            this.sessionService.revokeSession();
          }
          // If cookies are still valid, do nothing and keep the session.
        });
        return;
      }

      // If session user is gone but still authenticated, logout.
      // Exception: if a login is ongoing, do not log out.
      if (sessionUser === undefined && isAuthenticated && !ongoingLogin) {
        this.authService.logout();
      }
    }, {allowSignalWrites: true});
  }
}
